import React from "react";
import "./Experience.css";

function Experience() {
  return (
    <section id="experience" className="experience-section">
      <h2>Experience & Certifications</h2>

      <div className="experience-grid">
        <div className="experience-card">
          <h3>Artificial Intelligence Internship</h3>
          <h4>From Edunet Founation Approved By AICTE </h4>
          <p className="duration">Feb 2025 - March 2025</p>
          <p className="details">
            Worked on ML models, data preprocessing, and model evaluation using
            Python, TensorFlow, and Scikit-learn.
            Learned and applied supervised & unsupervised ML techniques on practical
            datasets.
          </p>
        </div>

        <div className="experience-card">
          <h3>Python & Machine Learning Applications Internship</h3>
          <h4>From Sure PROED Approved By AICTE</h4>
          <p className="duration">April 2025 - Sep 2025</p>
          <p className="details">
            Completed a 6-month internship focusing on Python programming and
            real-world ML applications.Hands-on experience with data preprocessing (NumPy, Pandas), visualization
            (Matplotlib, Seaborn), and ML algorithms (regression, classification,
            clustering).Developed a real-world ML project applying learned concepts, improving
            analytical and problem-solving skills.
          </p>
        </div>

        <div className="experience-card">
          <h3>Data Analytics Internship</h3>
          <h4>Issued By Deloitte Australia</h4>
          <p className="duration">October 2025</p>
          <p className="details">
            Completed a Deloitte job simulation involving data analysis and forensic technology.Created a data dashboard using Tableau.
            Used Excel to classify data and draw business conclusions
          </p>
        </div>

        <div className="experience-card">
          <h3>Data Science Internship</h3>
          <h4>Issued By PPRODIGY INFOTECH</h4>
          <p className="duration">August 2025</p>
          <p className="details">
            worked on various datasets such global_cancer_patients_dataset,Titatic_Dataset,
            bank_marketing_dataset,
            global_traffic_accidents_dataset as to extract 
            the useful insights with the help of data visualizations techniques.
          </p>
        </div>
      </div>

      <h3 className="subheading">Certifications</h3>

      <div className="cert-grid">
        <div className="cert-card">
          <h4>Applied Data Sciencce Lab</h4>
          <p>Issued By World Quant University</p>
          <a
            href="https://www.credly.com/badges/79b17aaa-759d-41ed-881d-4baf743946a4/public_url"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>Python Essentials</h4>
          <p>Issued By CISCO</p>
          <a
            href="https://www.credly.com/badges/93b922be-dd0d-4558-a0b6-9a0ac00b58fc/public_url"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>Junior Cybersecurity Analyst Career Path</h4>
          <p>Issued By CISCO</p>
          <a
            href="https://www.credly.com/badges/77ff2e0f-d61a-434b-9978-99c180981b1c/public_url"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>Introduction to Cybersecurity</h4>
          <p>Issued By CISCO</p>
          <a
            href="https://www.credly.com/badges/b642b8c8-8566-462f-b4e8-971dfd2a792d/public_url"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>British Airways's Data Science on Forage</h4>
          <p>Issued By British Airways</p>
          <a
            href="https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/tMjbs76F526fF5v3G/NjynCWzGSaWXQCxSX_tMjbs76F526fF5v3G_2wbJWDefDiygKNMMG_1751385544827_completion_certificate.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>SQL Certification</h4>
          <p>Issued By Hackerrank</p>
          <a
            href="https://www.hackerrank.com/certificates/64b42d4a22ff"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>Machine Learning</h4>
          <p>Issued By Kaggle</p>
          <a
            href="https://www.kaggle.com/learn/certification/gvivekchary/intermediate-machine-learning"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>Pandas for Data Manipulation</h4>
          <p>Issued By Kaggle</p>
          <a
            href="https://www.kaggle.com/learn/certification/gvivekchary/pandas"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>

        <div className="cert-card">
          <h4>Data Visualization with Python</h4>
          <p>Issued By Cognitive Class</p>
          <a
            href="https://courses.cognitiveclass.ai/certificates/93b205427f6347d4af1b139b52abcb35"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Certificate
          </a>
        </div>
      </div>
    </section>
  );
}

export default Experience;
